var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"container-content"},[_c('div',{staticClass:"d-flex align-items-center flex-column p-5"},[_c('h2',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.$t('pages.under_construction.heading')))]),_c('h3',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.$t('pages.under_construction.coming_soon')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }